<template>
  <layout-admin-dashboard-view
    :show-toolbar="false"
    :back-route="{ name: 'dashboard' }">
    <template #title>
      <span>{{ translateTitleCase("ls.founderBoard.admin.displayTitle") }}</span>
    </template>

    <template #default>
      <custom-crud-list v-bind="listConfiguration">
        <!--
        <template #cell-VendorId="{ item }">
          <span>{{ item.Vendor ? item.Vendor?.name : '-' }}</span>
        </template>
    -->
        <template #cell-OwnerId="{ item }">
          <span>
            <span v-if="item.Owner?.fullName">
              {{ item?.Owner?.fullName }}
            </span>
            <span v-else> - </span>
          </span>
        </template>
      </custom-crud-list>
    </template>
  </layout-admin-dashboard-view>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations";
import CustomCrudList from "@/client/components/crud/customV1/List.vue";

export default {
  components: { CustomCrudList },
  layout: "adminDashboard",
  middleware: {
    requireSuperAdmin: {},
  },
  setup(props) {
    let { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props);
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  meta: "ls.founderBoard.admin.pageTitle",
  data: function () {
    return {
      listConfiguration: {
        subject: "founderBoard",
        listSrc: "entity/founderBoard",
        showIdField: true, // bool deafult true
        sortable: false, //bool, default false
        publishable: true, //bool, default false
        enableMassActions: true,
        deleteRoute: "entity/founderBoard",
        createRoute: (item) => {
          this.$router.push({
            name: "admin-entity-entityType-create",
            params: { entityType: "founderBoard" },
          });
        },
        editRoute: (item) => {
          this.$router.push({
            name: "admin-entity-entityType-edit-entityId",
            params: { entityType: "founderBoard", entityId: item.id },
          });
        },
        editRoutePrefix: "",
        createRoutePrefix: "",
        deleteRoutePrefix: "",
        additionalListData: {
          simplified: false,
          translate: false,
        },
        fields: {
          // these are the table columns
          name: {
            itemKey: "name",
            label: "ls.founderBoard.fields.name",
            filterable: true, // boolean, or object
            orderable: true,
          },
          alias: {
            itemKey: "alias",
            label: "ls.founderBoard.fields.alias",
            filterable: true, // boolean, or object
            orderable: true,
          },
          displayName: {
            itemKey: "displayName",
            label: "ls.founderBoard.fields.displayName",
            filterable: true, // boolean, or object
            orderable: true,
          },
          OwnerId: {
            itemKey: "OwnerId",
            label: "ls.founderBoard.fields.OwnerId",
          },
        },
        actions: {
          show: false,
          edit: true,
          delete: true,
          custom: {
            goTo: {
              //tooltip
              tooltip: { content: "ls.founderBoard.admin.goTo" },
              icon: "link",
              theme: "inverse",
              //text
              handler: async ({ item }) => {
                const routeData = this.$router.resolve({
                  name: "founders-founderBoardAlias",
                  params: { founderBoardAlias: item.alias },
                });

// Open the resolved URL in a new window or tab
                window.open(routeData.href, "_blank");
              //  this.$router.push({
              //    name: "founders-founderBoardAlias",
              //    params: { founderBoardAlias: item.alias },
              //  });
              },
            },
          },
        },
      },
    };
  },
};
</script>

<style scoped lang="scss"></style>
